import { z } from "zod"
import { stringRequired } from "@/models/common"
import { Language } from "@/modules/patients/detail/therapy-prescription/ch/services/__generated__/useChCreatePsychologicalPsychoTherapyMutation.graphql.ts"

export const deReferralSchema = z.object({
  reasoning: z.string().optional(),
  diagnosisCode: stringRequired,
  allergies: z.array(z.string()).readonly().optional(),
  conditions: z.array(z.string()).readonly().optional(),
  medicationIds: z.array(z.string()).readonly().optional(),
})

export const chReferralSchema = z.object({
  reasoning: z.string().max(1000, { message: "common.fieldErrorList.maxCharLimit" }).optional(),
  diagnosisCode: stringRequired,
  documentLanguage: z.custom<Exclude<Language, "ENGLISH">>((language) => !!language, {
    message: "common.fieldErrorList.requiredField",
  }),
  careProviderCopyToIds: z.array(z.string()).readonly().nullable(),
  allergies: z.array(z.string()).readonly().optional(),
  conditions: z.array(z.string()).readonly().optional(),
  medicationIds: z.array(z.string()).readonly().optional(),
})

export type DeReferralSchema = z.infer<typeof deReferralSchema>

export type ChReferralSchema = z.infer<typeof chReferralSchema>
